import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classNames from 'classnames';
export var flexWrapValues = ['wrap', 'nowrap', 'wrap-reverse'];
export var justifyContentValues = ['flex-start', 'flex-end', 'start', 'end', 'center', 'space-between', 'space-around', 'space-evenly', 'stretch', 'normal', 'left', 'right'];
export var alignItemsValues = ['center', 'start', 'end', 'flex-start', 'flex-end', 'self-start', 'self-end', 'baseline', 'normal', 'stretch'];
var genClsWrap = function genClsWrap(prefixCls, props) {
  var wrap = props.wrap === true ? 'wrap' : props.wrap;
  return _defineProperty({}, "".concat(prefixCls, "-wrap-").concat(wrap), wrap && flexWrapValues.includes(wrap));
};
var genClsAlign = function genClsAlign(prefixCls, props) {
  var alignCls = {};
  alignItemsValues.forEach(function (cssKey) {
    alignCls["".concat(prefixCls, "-align-").concat(cssKey)] = props.align === cssKey;
  });
  alignCls["".concat(prefixCls, "-align-stretch")] = !props.align && !!props.vertical;
  return alignCls;
};
var genClsJustify = function genClsJustify(prefixCls, props) {
  var justifyCls = {};
  justifyContentValues.forEach(function (cssKey) {
    justifyCls["".concat(prefixCls, "-justify-").concat(cssKey)] = props.justify === cssKey;
  });
  return justifyCls;
};
function createFlexClassNames(prefixCls, props) {
  return classNames(Object.assign(Object.assign(Object.assign({}, genClsWrap(prefixCls, props)), genClsAlign(prefixCls, props)), genClsJustify(prefixCls, props)));
}
export default createFlexClassNames;